import * as React from 'react'

import { Skeleton } from 'components/ui/skeleton'

const LoadingHomeSkeleton = React.memo(({}) => {
    return (
        <div className="flex w-full gap-3 h-[100px]">
            <Skeleton className="w-1/3 bg-neutral-200 h-full" />
            <Skeleton className="w-1/3 bg-neutral-200 h-full" />
            <Skeleton className="w-1/3 bg-neutral-200 h-full" />
        </div>
    )
})

export default LoadingHomeSkeleton
